<template>
  <el-row class="search">
    <el-row class="su-card mb20 search-card">
      <su-title title="条件筛选" :more="false"/>
      <div class="mt20">
        <el-row class="flex">
          <div class="mb20" style="min-width: 65px;">栏目分类</div>
          <div class="flex war-pe">
            <div
                class="searchListFiltering mb20"
                :class="{active:queryParams.type == item.id}"
                v-for="(item,index) in columnClassificationList"
                @click="columnClassification(item)"
                :key="index">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </el-row>
        <el-row class="flex al-cn war-pe">
          <div class="mr15 mb15">内容搜索</div>
          <div class="flex al-cn mb15">
            <el-input placeholder="输入关键字" v-model="queryParams.keyword"></el-input>
            <el-button type="danger" @click="search" style="background-color: #C32912;border: none">搜索</el-button>
          </div>
        </el-row>
      </div>
    </el-row>
    <el-row class="su-card search-card">
      <su-title title="列表" :more="false" :custom="true">
        <el-row class="flex al-cn">
          <div
              class="searchListFiltering"
              :class="{active:queryParams.sort == item.id}"
              v-for="(item,index) in typeList"
              @click="timeSort(item)"
              :key="index">
            <i class="el-icon-time mr5"></i>
            <span>{{ item.name }}</span>
          </div>
        </el-row>
      </su-title>
      <list-item :item="item" v-for="(item,index) in list" :key="index" @detailsClick="detailsClick(item)"/>
      <el-empty :image-size="100" v-if="!list || list.length == 0"></el-empty>
      <div class="flex ju-cn mt15">
        <pagination
            v-show="total > 0"
            :total="total"
            layout="prev, pager, next"
            :page.sync="queryParams.page"
            :limit.sync="queryParams.size"
            @pagination="search"
        />
      </div>
    </el-row>
  </el-row>
</template>
<script>

import {search} from "@/api/api";

export default {
  data() {
    return {
      type: '时间排序',
      typeList: [
        {
          id: 'date',
          name: '时间排序',
        }, {
          id: 'invite',
          name: '浏览量排序',
        }
      ],
      list: [],
      columnClassificationList: [
        {
          id: '',
          cate_id: '',
          name: '不限',
        }, {
          id: 3,
          cate_id: 10,
          name: '考试与报名',
        }, {
          id: 1,
          cate_id: 1,
          name: '最新资讯',
        }, {
          id: 2,
          cate_id: 8,
          name: '资源中心',
        }, {
          id: 4,
          cate_id: 17,
          name: '关于我们',
        }
      ],
      queryParams: {
        page: 1,
        size: 10,
        type: '', //类型1:'最新资讯' ,2:'资源中心',3:'考试与报名',4:'关于我们'
        cate_id: '', //分类id
        keyword: '', //关键字
        order: 'asc', //desc倒序，asc正序
        sort: 'date', //排序 date 发布时间 invite点击量
      },
      // 总条数
      total: 0,
    }
  },
  mounted() {

  },
  created() {
    this.search()
  },
  methods: {
    // 详情
    detailsClick(data) {
      this.$router.push({
        path: '/search/details',
        query: {
          id: data.id,
        }
      });
    },
    columnClassification(e) {
      this.queryParams.type = e.id
    },
    timeSort(e) {
      this.queryParams.sort = e.id
    },
    search() {
      this.loading = true;
      search(this.queryParams).then(res => {
        this.loading = false;
        if (res.status === 200) {
          this.list = res.data.data
          this.total = res.data.total || 0;
        }
      }).catch(error => {
        this.loading = false;
      });
    }
  }
}
</script>

<style scoped lang="scss">
.search{
  &-card{
    padding: 20px 50px;
  }
}
.searchListFiltering {
  border-radius: 2px 2px 2px 2px;
  padding: 5px 10px;
  font-size: 13px;
  color: #333333;
  background: #EEEEEE;
  margin-left: 15px;
  cursor: pointer;

  //当被选中时
  &.active {
    background: #C32912;
    color: #FFFFFF;
  }
}

.dataList {
  &-description {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    white-space: normal;
  }
}
@media (max-width: 750px) {
  .search{
    &-card{
      padding: 20px;
    }
  }
}
</style>
